import API from 'services/api';

export const getEVisitorConnectionStatus = (
  unitId: string | undefined,
): Promise<boolean> | undefined => {
  if (unitId === undefined) {
    return undefined;
  }

  return API.get(`/api/accommodation/properties/units/${unitId}/eVisitor-account-status`).then(
    response => response?.data,
  );
};
